// Demo popup + fake forms for the landing page. Nothing is sent anywhere.
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector(".js-modal");
  if (!modal) return;

  const panels = modal.querySelectorAll("[data-panel]");
  let lastFocus = null;

  const show = (name) => {
    panels.forEach((p) => { p.hidden = p.dataset.panel !== name; });
  };

  const open = (name) => {
    lastFocus = document.activeElement;
    show(name);
    if (typeof modal.showModal === "function") {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute("open", "");
    }
    document.body.classList.add("locked");
    const first = modal.querySelector("[data-panel]:not([hidden]) input, [data-panel]:not([hidden]) button:not(.lp-modal__close)");
    if (first) first.focus();
  };

  const close = () => {
    if (typeof modal.close === "function" && modal.open) modal.close();
    else modal.removeAttribute("open");
  };

  modal.addEventListener("close", () => {
    document.body.classList.remove("locked");
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  });

  // Every "Get the program" button carries data-open-modal (see
  // wps_checkout_link_attrs()); with a real checkout URL set it is a plain link.
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-open-modal]");
    if (trigger) {
      e.preventDefault();
      open(trigger.dataset.openModal);
      return;
    }
    if (e.target.closest(".js-modal-close")) close();
    // Click on the backdrop (the <dialog> itself, outside the box).
    if (e.target === modal) close();
  });

  const fill = (key, value) => {
    modal.querySelectorAll(`[data-fill="${key}"]`).forEach((el) => { el.textContent = value; });
  };

  document.querySelectorAll(".js-demo-form").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const err = form.querySelector("[data-error]");
      const data = new FormData(form);
      const email = String(data.get("email") || "").trim();
      const nameField = form.elements.name;
      const name = nameField ? String(data.get("name") || "").trim() : "x";

      if (email.indexOf("@") < 1 || !name) {
        if (err) err.hidden = false;
        const bad = !name && nameField ? nameField : form.elements.email;
        bad.focus();
        return;
      }
      if (err) err.hidden = true;

      fill("email", email);
      if (form.dataset.demo === "checkout") {
        fill("name", name);
        fill("start", String(data.get("start") || "Monday"));
        open("checkout-done");
      } else {
        open("starter-done");
      }
    });
  });
});
